// extracted by mini-css-extract-plugin
module.exports = {"progress":"ProgressBar_progress__3JWzf"};